import { DatePipe } from '@angular/common';
import { ChangeDetectorRef, Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { MdbTableDirective, ModalDirective } from 'angular-bootstrap-md';
import { AlertService } from 'ngx-alerts';
import { AbonosService } from '../abonos.service';
import { Clientes } from '../cliente';
import { ClienteService } from '../cliente.service';
import { CuentasxcobrarService } from '../cuentasxcobrar.service';
import { CxC } from '../cxc';
import { Emisor } from '../emisor';
import { EmisorService } from '../emisor.service';
import { Pagos } from '../pagos';

@Component({
  selector: 'app-abonos',
  templateUrl: './abonos.component.html',
  styleUrls: ['./abonos.component.scss']
})
export class AbonosComponent implements OnInit {

  listaAbonos:Pagos []=[];

  cuenta:CxC= new CxC();
  listaCXC:CxC[]=[];
  id:string;
  total:number;
  pago:Pagos=new Pagos();

  listCliene: Clientes[];
  entidadCXC:CxC= new CxC();
  @ViewChild(MdbTableDirective) mdbTable: MdbTableDirective;
  editField: string;
  emisor:Emisor = new Emisor();
 
  constructor( private apiClien: ClienteService,  private apiEmisor: EmisorService,private apiCxC: CuentasxcobrarService,private datePipe: DatePipe,private route: ActivatedRoute,private apiCXC:CuentasxcobrarService,private ruter: Router,private alertService: AlertService,private api: AbonosService, private cdRef: ChangeDetectorRef) { }

  ngOnInit(): void {
    this.datosCliente();
    this.cargarDatos();
    this.total=0.0;
    this.apiEmisor.getEmisor(localStorage.getItem('id')).subscribe(( data: Emisor[])=>{
      data.forEach(item => {
          this.emisor=item;

      })})
  }
  PadLeft(value, length) {
    return (value.toString().length < length) ? this.PadLeft("0" + value, length) : 
    value;
  }

  
  
  variableNula(valor) {

    if (valor == null || valor == undefined || valor == "null" || 
    valor == "undefined") { 
      return false } else { 
        return true }

  }
  guardar(){

    this.api.guardarPagos(this.listaAbonos).subscribe(

      data  => {
        this.alertService.success("Se actualizo con exito..");
      this.cargarDatos();
      this.listaCXC[0]=this.cuenta;
      this.apiCxC.setActulizar(this.listaCXC).subscribe(

        data  => {
        },
      
        error  => {
        
       this.alertService.danger(error)
        
        });
      
      },
      
      error  => {
      
     this.alertService.danger(error)
      
      }
      
      );
  }

  datosCliente(){
   this.id= this.route.snapshot.paramMap.get('id');
   this.apiCXC.cuentaxCobrar(this.id).subscribe((
    data: CxC) => {
    this.cuenta = data;
    if (this.cuenta.tipoDoc=='F'){
      this.cuenta.tipoDoc='FACTURA'
    }
    if(this.cuenta.tipoDoc=='R'){
      this.cuenta.tipoDoc='RECIBO'
    }
    if (this.variableNula(this.cuenta.numeroDocumento)==true){
   this.cuenta.numeroDocumento=this.PadLeft(this.cuenta.numeroDocumento,9);
    }
   this.cargarDatos();
   this.listaCXC[0]=this.cuenta;
   this.apiCxC.setActulizar(this.listaCXC).subscribe(

     data  => {
     },
   
     error  => {
     
    this.alertService.danger(error)
     
     });
    
  }
    , err => {
      console.log(err);
      
    });
  }


  cargarDatos(){
    this.id= this.route.snapshot.paramMap.get('id');
    this.api.getAbonos(this.id).subscribe((
     data: Pagos[]) => {
       
       console.log(data);
       this.listaAbonos=data;

       this.listaAbonos.forEach(e=>{
     e.fechaPago= this.datePipe.transform(e.fechaPago, 'yyyy-MM-dd');
 

       });
       this.mdbTable.setDataSource(this.listaAbonos);
       this.total=0.0;
       this.listaAbonos.forEach(e=>{
         this.total=e.valor+this.total;
       })
       this.cuenta.saldo=this.cuenta.valor-this.total;
       this.listaCXC[0]=this.cuenta;
      this.apiCxC.setActulizar(this.listaCXC).subscribe(

        data  => {
        },
      
        error  => {
        
       this.alertService.danger(error)
        
        });
     
   }
     , err => {
       console.log(err);
       
     });
   }

  add() {
    if (this.listaAbonos.length >= 0) {
      let entidad= new Pagos();
      entidad.id=0;
      entidad.idCxc=Number.parseInt(this.id);
      entidad.idCliente=this.cuenta.idCliente.toString();
      entidad.idEmisor= Number.parseInt(localStorage.getItem("id"));
      entidad.saldo=this.cuenta.valor;
      entidad.enviado='S'
      this.listaAbonos.push(entidad);
      this.mdbTable.setDataSource(this.listaAbonos);
 
    }
  }

regresar(){
  this.ruter.navigate(['cxc' ]);
}

  eliminar(numero: number){
if (this.listaAbonos[numero].id===null){

    this.listaAbonos.splice(numero,1);
   
    this.mdbTable.setDataSource(this.listaAbonos);
    this.mdbTable.dataSourceChange();
  }else{
    this.api.eliminarCliente(this.listaAbonos[numero].id).
    subscribe(

      data  => {
        this.alertService.success("Se elimino con exito..");
        this.cargarDatos();
      
      },
      
      error  => {
      
     this.alertService.danger(error)
      
      }
      
      );
  }

}
  changeValue(event: any) {
    this.total=0.0;
    this.listaAbonos.forEach(e=>{
      this.total=e.valor+this.total;
    })
    this.cuenta.saldo=this.cuenta.valor-this.total;
  }
  

  print(entidad:Pagos){
    this.pago=entidad;
    const printContent = document.getElementById('component2');
    const WindowPrt = window.open('', '', 'left=0,top=0,width=900,height=900,toolbar=0,scrollbars=0,status=0');
    WindowPrt.document.write(printContent.innerHTML);
    WindowPrt.document.close();
    WindowPrt.focus();
    WindowPrt.print();

  
  }


}
